// delForm/state.js

import { jsaFormInitialState } from "../jsaForm/jsaFormState";
import { wasteDisposalInitialState } from "../wasteDisposalForm/wasteDisposalFormState";
import { photosUIInitialState } from "../photosForm/photosFormState";

// Autosave error tracking state
export const autosaveErrorsInitialState = {
  hasErrors: false,
  lastError: null, // { key, message, timestamp, patchType, rowId? }
  fieldErrors: {}, // { "project.del_date": "Invalid date format" }
  rowErrors: {}, // { "employee_uuid123": { employeeId: "Required" } }
};

export const projectUIInitialState = {
  loading: false,
  showProjectDropdown: false,
  showPhaseDropdown: false,
  showTaskDropdown: false,
  showJsaTab: true,
  showWasteDisposalTab: true,
  showClientSignaturesTab: false,
};

export const employeeUIInitialState = {
  loading: false,
};

export const unitsUIInitialState = {
  loading: false,
  activeTab: "All",
  activeUnitView: { tabSearchUnits: "all-units", tabName: "All Units" },
  allUnitSearch: true,
  activeProjectUnitView: "all",
  availableProjectUnits: {},
};

export const fieldNotesUIInitialState = {
  loading: false,
  generalWorkDescriptionWeatherCollapsed: false,
};

export const clientSignaturesUIInitialState = {
  loading: false,
  signatureModalOpen: false,
  currentSignatureRowId: null,
  currentSignatureImage: null,
  currentSignatureName: null,
  currentSignatureTitle: null,
  currentSignatureCompany: null,
};

export const miscUIInitialState = {
  activeMiscTab: "photos", // "photos" | "wasteDisposal" | "clientSignatures" | "sds"
};

export const delFormInitialState = {
  projectUI: projectUIInitialState,
  employeeUI: employeeUIInitialState,
  unitsUI: unitsUIInitialState,
  fieldNotesUI: fieldNotesUIInitialState,
  clientSignaturesUI: clientSignaturesUIInitialState,
  jsaFormUI: jsaFormInitialState,
  wasteDisposalFormUI: wasteDisposalInitialState,
  miscUI: miscUIInitialState,
  photosUI: photosUIInitialState,
  autosaveErrors: autosaveErrorsInitialState,
};
